// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TOOLBAR_REPLYING_TO = "Odpov\u00edd\u00e1\u0161 na:";
